import {
  ViewTemplateLayoutText,
  getLayoutText,
} from '@shared/scenes/workflows/viewTemplateLayoutItems';
import { LayoutItemMarkdown } from './LayoutItemMarkdown';
import styles from './layoutItems.module.css';

/** A text layout item in a form. Renders nothing while it holds no text worth showing. */
export function LayoutTextItem({ item }: { item: ViewTemplateLayoutText }) {
  const text = getLayoutText(item);

  if (!text) {
    return null;
  }

  return <LayoutItemMarkdown source={text} className={`${styles.item} ${styles.text}`} />;
}
